export default __webpack_public_path__ + "static/media/headTitle.877f2e4c.png";